import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  showCategory?: boolean;
}

export default function ComicCard({ comic, showCategory = true }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 韩漫免费漫画`}
          title={`${comic.title} - 韩漫在线免费看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 right-2">
          {comic.status === '连载中' ? (
            <span className="px-2 py-1 text-xs font-medium rounded-full bg-primary-500 text-background-50">连载</span>
          ) : (
            <span className="px-2 py-1 text-xs font-medium rounded-full bg-secondary-500 text-background-50">完结</span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-2 text-background-50 text-xs">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-eye-line"></i>
            </div>
            <span>{comic.views > 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}</span>
            <span className="ml-auto flex items-center gap-1">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-star-fill text-accent-500"></i>
              </div>
              {comic.rating}
            </span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-xs text-foreground-500">{comic.author}</span>
          {showCategory && (
            <>
              <span className="text-xs text-foreground-300">·</span>
              <span className="text-xs text-primary-600 bg-primary-50 px-1.5 py-0.5 rounded">{comic.category}</span>
            </>
          )}
        </div>
        <p className="text-xs text-foreground-400 mt-2 line-clamp-2 leading-relaxed">
          {comic.description}
        </p>
        {comic.chapters.length > 0 && (
          <p className="text-xs text-accent-600 mt-2 whitespace-nowrap">
            最新: {comic.chapters[0].title}
          </p>
        )}
      </div>
    </Link>
  );
}